module.exports = __webpack_public_path__ + "media/state-press-3_1200.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/state-press-3_1200.jpg
// module id = 43
// module chunks = 0